import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCommits: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCommits"><Path d="M12 6C15.0596 6 17.582 8.29041 17.9512 11.25H23V12.75H17.9512C17.582 15.7096 15.0596 18 12 18C8.94039 18 6.41803 15.7096 6.04883 12.75H1V11.25H6.04883C6.41803 8.29041 8.94039 6 12 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCommits;
